const defectTypeKeys = {
    inspection: "Inspection",
    event: "Event",
    check: "Check",
    tyreCheck: "TyreCheck"
};

const defectTypeKeysByName = {
    "Tyre Check": defectTypeKeys.tyreCheck
};

function isInspectionDefect(defect) {
    return defect?.defectTypeKey === defectTypeKeys.inspection;
}

// Stored list filters may hold a defect type's display name; the search takes its key.
function getDefectTypeKey(defectTypeValue) {
    return defectTypeKeysByName[defectTypeValue] ?? defectTypeValue;
}

// A defect from a multi-vehicle visit opens the visit summary, which shows every vehicle's report; any other defect opens
// its own report. A search row carries the report id on its parent; the single-defect read carries it on the defect.
function getInspectionReportUrl(defect) {
    if (defect?.summaryContainerId) {
        return `${window.env.VISION_URL}/#/WorkItemReport/WorkItemSummary/${defect.summaryContainerId}`;
    }
    const reportId = defect?.reportId ?? defect?.parent?.reportId;
    if (!reportId) {
        return null;
    }
    return `${window.env.VISION_URL}/#/WorkItemReport/${reportId}`;
}

// The legacy report opened at the defect; the report alone when the defect's legacy id is not known.
function getInspectionDefectUrl(defect) {
    const reportUrl = getInspectionReportUrl(defect);
    if (!reportUrl || defect.inspectionDefectId == null) {
        return reportUrl;
    }
    return `${reportUrl}?defectId=${defect.inspectionDefectId}`;
}

// The legacy report's Defects tab opened at the defect, where the defect is signed off. The legacy page opens the
// report at the defect instead when the user cannot see that tab.
function getInspectionDefectsTabUrl(defect) {
    const reportUrl = getInspectionReportUrl(defect);
    if (!reportUrl || defect.inspectionDefectId == null) {
        return null;
    }
    return `${reportUrl}?defectId=${defect.inspectionDefectId}&tab=defects`;
}

// Decides how a defect's status can be updated: an inspection defect links to the legacy Defects tab at that defect,
// any other source opens the sign-off dialog until it is rectified. Returns null when no update is offered.
function getUpdateStatusAction(defect, canUpdateStatus, canOpenInspectionReport) {
    if (!canUpdateStatus(defect)) {
        return null;
    }

    if (isInspectionDefect(defect)) {
        const href = canOpenInspectionReport ? getInspectionDefectsTabUrl(defect) : null;
        return href ? { href } : null;
    }

    if (defect.rectified) {
        return null;
    }

    return { signoff: true };
}

export const DefectHelperFunctions = {
    defectTypeKeys,
    isInspectionDefect,
    getDefectTypeKey,
    getInspectionReportUrl,
    getInspectionDefectUrl,
    getInspectionDefectsTabUrl,
    getUpdateStatusAction
};
